import { render, staticRenderFns } from "./Finance1.container.vue?vue&type=template&id=60dc4780&scoped=true&"
import script from "./Finance1.container.vue?vue&type=script&lang=js&"
export * from "./Finance1.container.vue?vue&type=script&lang=js&"
import style0 from "./Finance1.container.vue?vue&type=style&index=0&id=60dc4780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc4780",
  null
  
)

export default component.exports